<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12a45iu/tc-custom/9780310357452.jpg?1728259438160" alt="This image is the cover for the book Revival Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Revival Fire
      </h1>
      <p class="bookDescription body article font2">
        <p>Fire blazes from heaven, and a stone altar erupts in flame. So begins a spiritual awakening, the kindling of a revival fire still burning today. Beginning with Elijah and God's tremendous one-day revival of Israel, Wesley Duewel tells stories of revivals spanning the globe from America to China to Africa, all brought by obedience and heartfelt prayer. He illustrates how God has used revival fire through the centuries to revive the church and reveal the glorious presence of the Holy Spirit.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wesley Duewel
      </h2>
      
      <p class="authorDescription body article"><P>Dr. Wesley Duewel has given himself to the cause of missions for more than 70 years.&#160; Following ministry in India for nearly 25 years, he served as president of OMS International and is now President Emeritus. Dr. Duewel has a deep love for the Word of God. He has read the entire Bible through nearly 200 times. People around the world have appreciated his biblical insight with more than two million copies of his books in print in over 50 languages. Continuing his active life-long ministry &#160;at 96, he teaches a senior adult Sunday School class and enjoys sharing his testimony to God’s faithfulness.&#160; He carries a deep concern for the unevangelized millions and a constant emphasis upon prayer as the key to revival.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bcdba39c